export type Route =
  | 'onboarding'
  | 'home'
  | 'breath'
  | 'mantra'
  | 'drift'
  | 'sound'
  | 'night3am'
  | 'ledger'
  | 'checkin'
  | 'companion'
  | 'settings'
  | 'safety'

const ROUTES: readonly Route[] = [
  'onboarding',
  'home',
  'breath',
  'mantra',
  'drift',
  'sound',
  'night3am',
  'ledger',
  'checkin',
  'companion',
  'settings',
  'safety',
]

type Handler = (route: Route) => void

let handler: Handler = () => {}
/** Each screen gets a signal that fires the moment the user leaves it, so no
 *  breathing loop, timer or speech queue outlives its own screen. */
let leaving: AbortController | null = null

export function currentRoute(): Route {
  const hash = location.hash.replace(/^#\/?/, '') as Route
  return ROUTES.includes(hash) ? hash : 'home'
}

export function go(route: Route): void {
  if (currentRoute() === route) {
    dispatch()
    return
  }
  location.hash = `#/${route}`
}

export function back(): void {
  if (history.length > 1) history.back()
  else go('home')
}

export function leaveSignal(): AbortSignal {
  return leaving!.signal
}

function dispatch(): void {
  leaving?.abort()
  leaving = new AbortController()
  handler(currentRoute())
}

export function startRouter(onRoute: Handler): void {
  handler = onRoute
  window.addEventListener('hashchange', dispatch)

  // PWA shortcuts arrive as ?go=night3am. Convert once, then clean the URL so a
  // refresh doesn't drop the user back into 3AM mode at noon.
  const params = new URLSearchParams(location.search)
  const target = params.get('go') as Route | null
  if (target && ROUTES.includes(target)) {
    history.replaceState(null, '', `${location.pathname}#/${target}`)
  }

  dispatch()
}
